export const transition = { 
    duration: .25, 
    ease: [.56, .03, .12, 1.04]
};

export const variants = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1
    },
    qrInitial: {
        opacity: 0,
        x: '10rem',
        rotate: '15deg'
    },
    qrAnimate: width => ({
        opacity: 1,
        x: 0,
        rotate: 0,
        transition: {
            ...transition,
            duration: .5,
        }
    }),
    toolInitial: {
        opacity: .7,
    },
    toolAnimate: {
        opacity: 1
    }
};
